import { createProviderToken } from '@core/common-legacy';
import type {
  DetailsDimensionsData,
  ReportDashboardComponent,
  ReportDashboardMetricOptions,
  ReportResults,
  VisualizationDataTypeUnion,
} from '@core/reports-types';
import type { DialogComponentI } from '@core/user-interface-legacy';

export const { inject: injectReportsDetailsDialog, provide: provideReportsDetailsDialog } =
  createProviderToken<new (...args: any[]) => DialogComponentI<any, any>>(
    'REPORTS_DETAILS_DIALOG_TOKEN',
  )();

export type DetailsDataBuilderInput = {
  metric: ReportDashboardMetricOptions;
  component: ReportDashboardComponent;
  data: VisualizationDataTypeUnion;
  rawComponent: ReportDashboardComponent;
  visResponse: ReportResults;
};

export type DetailsDataBuilder = (
  dimensions: DetailsDimensionsData,
  props: DetailsDataBuilderInput,
) => unknown;

export const {
  inject: injectReportsDetailsDataBuilder,
  provide: provideReportsDetailsDataBuilder,
} = createProviderToken<DetailsDataBuilder>('DetailsDataBuilder')();
